import React from "react";
// import Progress from "../Progress";
import "../ContentPages/style.css";
import SubmitButton from "../Buttons/SubmitButton";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../contexts/AppContext.jsx";
import { updateApplication } from "../../Services/applicationService";
import Loader from "../Loader/Loader";

const PhotoVerificationFailed = ({ handleNext, handleCancel, handleBack }) => {
  const { userFlows, appState, setAppState } = React.useContext(AppContext);
  const [validating, setValidating] = React.useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (userFlows?.isRenew) {
      console.log("renew flow")
      setValidating(true);
      const updatedAppState = {
        ...appState,
        requestPayload: {
          ...appState.requestPayload,
          photoShop: { flag: true },
        },
      };
      setAppState(updatedAppState);
      updateApplication(updatedAppState.requestPayload).then(
        (resp) => {
          console.log("Application updated successfully: ", resp)
          navigate("/app/application-at-store");
          setValidating(false)
        }
      ).catch((error) => {
        console.error("Error submitting application:", error);
        setValidating(false);
      });

    } else {
      navigate("/app/photo-id");
    }
  };

  return (
    <>
      {validating && <Loader />}
      <div className="intro">
        {/* <Progress progress={40} /> */}
        <h1 className="intro-title-mi" lang="mi-NZ">
          Kāore anō kia oti i a koe tō hāpono whakaahua
        </h1>
        <hr />
        <h1 className="intro-title">
          You have not completed photo verification
        </h1>

        <div className="step-container">
          <p className="mb-4">
            You'll need to finish your application in person at a RealMe partner
            store.
          </p>
        </div>
      </div>

      <div className="step-button-container">
        <SubmitButton text={"Continue"} onClick={handleSubmit} />
      </div>
      <div className="checkbox-wrapper mb-5">
        <label className="terms-label">
          <a href="#" className="cancel-link" onClick={handleSubmit}>
            I want my photo taken at a RealMe partner store instead
          </a>
        </label>
      </div>
    </>
  );
};

export default PhotoVerificationFailed;
